export interface ErrorInfo {
	Success: boolean;
	ErrorMessage: string;
}

export class SuPasswordCheck {
	private static MinLength: number = 12;
	private static MinLowercase: number = 1;
	private static MinUppercase: number = 1;
	private static MinNumber: number = 1;
	private static MinSpecial: number = 1;

	private static Alpha: string = "abcdefghijklmnopqrstuvwxyz";
	private static Num: string = "1234567890";

	public static CheckPassword(password: string): ErrorInfo {
		var Info: ErrorInfo = { Success: false, ErrorMessage: "Unknown Error" };

		//
		//  Length
		//
		if (password == undefined || password.trim().length < SuPasswordCheck.MinLength) {
			Info.Success = false;
			Info.ErrorMessage = "Password must be at least " + SuPasswordCheck.MinLength + " characters";
			return Info;
		}

		var lowerCaseCount: number = 0;
		var upperCaseCount: number = 0;
		var numberCount: number = 0;
		var specialCount: number = 0;

		for (var z = 0; z < password.length; z++) {
			var nextChar = password.substring(z, z + 1);

			if (SuPasswordCheck.Alpha.indexOf(nextChar) >= 0) {
				lowerCaseCount += 1;
			} else if (SuPasswordCheck.Alpha.toUpperCase().indexOf(nextChar) >= 0) {
				upperCaseCount += 1;
			} else if (SuPasswordCheck.Num.indexOf(nextChar) >= 0) {
				numberCount += 1;
			} else {
				specialCount += 1;
			}
		}

		//
		//  Lowercase check
		//
		if (lowerCaseCount < SuPasswordCheck.MinLowercase) {
			Info.Success = false;
			Info.ErrorMessage = "Password must have at least " + SuPasswordCheck.MinLowercase + " lowercase letters";
			return Info;
		}

		//
		//  Uppercase check
		//
		if (upperCaseCount < SuPasswordCheck.MinUppercase) {
			Info.Success = false;
			Info.ErrorMessage = "Password must have at least " + SuPasswordCheck.MinUppercase + " uppercase letters";
			return Info;
		}

		//
		//  Number check
		//
		if (numberCount < SuPasswordCheck.MinNumber) {
			Info.Success = false;
			Info.ErrorMessage = "Password must have at least " + SuPasswordCheck.MinNumber + " numbers";
			return Info;
		}

		//
		//  Special character check
		//
		if (specialCount < SuPasswordCheck.MinSpecial) {
			Info.Success = false;
			Info.ErrorMessage = "Password must have at least " + SuPasswordCheck.MinSpecial + " special characters";
			return Info;
		}

		//
		//  All Tests Passed
		//
		Info.Success = true;
		Info.ErrorMessage = "";

		return Info;
	}
}
